import { useContext } from "react";
import AppContext from "../utils/AppContext";
import { api } from "../utils/api";

export default function useCurrentUser() {
  const [state, dispatch] = useContext(AppContext);
  const { currentUser } = state;

  const updateUser = async (data, id = currentUser.id) => {
    const { data: userData } = await api.put(`/users/${id}/`, data);
    await dispatch({ type: 'currentUser/set', payload: userData });

    return userData;
  }

  const updateOnboarding = async data => {
    const onboarding = {
      ...currentUser.onboarding,
      ...data
    }

    return await updateUser({ onboarding });
  }

  return {
    currentUser,
    updateUser,
    updateOnboarding,
  }
}
